import { render, staticRenderFns } from "./ShowDataDialog.vue?vue&type=template&id=dd6f7134&scoped=true&"
import script from "./ShowDataDialog.vue?vue&type=script&lang=js&"
export * from "./ShowDataDialog.vue?vue&type=script&lang=js&"
import style0 from "./ShowDataDialog.vue?vue&type=style&index=0&id=dd6f7134&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6f7134",
  null
  
)

export default component.exports